import { Stack, Button, Typography } from "@mui/material";
import type { RootState } from "../../../../../store/Index";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

type activeTabType =
  | "tribute-comments"
  | "youtube-comments"
  | "media"
  | "upload"
  | "delivery";

interface Props {
  activeTab: string;
  setActiveTab: React.Dispatch<React.SetStateAction<activeTabType>>;
  commentsWaitingApproval: number;
}

export const TabButtons: React.FC<Props> = ({
  activeTab,
  setActiveTab,
  commentsWaitingApproval,
}) => {
  const reduxTheme = useSelector((state: RootState) => state.theme);

  const isTabButtonActive = (button: string) => {
    if (button === activeTab) {
      return `3px solid ${reduxTheme.primary_colors[400]}`;
    }
  };
  return (
    <Stack
      direction={"row"}
      gap={2}
      sx={{
        borderBottom: `1px solid ${reduxTheme.primary_colors[300]}`,
      }}
    >
      <Button
        disableElevation
        sx={{
          fontWeight: "bold",
          borderBottom: isTabButtonActive("tribute-comments"),
          borderRadius: "0 !important",
          pb: 1,
        }}
        onClick={() => setActiveTab("tribute-comments")}
        variant="text"
      >
        {`Tribute Comments`}
        <Typography
          variant="body2"
          sx={{
            borderRadius: "50%",
            width: "30px",
            height: "30px",
            color: "#fff",
            display: "grid",
            placeContent: "center",
            ml: 1,
            backgroundColor: "#048b3dff",
          }}
        >
          {commentsWaitingApproval}
        </Typography>
      </Button>

      <Button
        disableElevation
        sx={{
          fontWeight: "bold",
          borderBottom: isTabButtonActive("youtube-comments"),
          borderRadius: "0 !important",
          pb: 1,
        }}
        onClick={() => setActiveTab("youtube-comments")}
        variant="text"
      >
        {`Youtube Comments`}
        <Typography
          variant="body2"
          sx={{
            borderRadius: "50%",
            width: "30px",
            height: "30px",
            color: "#fff",
            display: "grid",
            placeContent: "center",
            ml: 1,
            backgroundColor: "#048b3dff",
          }}
        >
          0
        </Typography>
      </Button>

      <Button
        sx={{
          fontWeight: "bold",
          borderBottom: isTabButtonActive("media"),
          borderRadius: "0 !important",
          pb: 1,
        }}
        variant="text"
        onClick={() => setActiveTab("media")}
      >
        Images and Media
      </Button>
      <Button
        sx={{
          fontWeight: "bold",
          borderBottom: isTabButtonActive("upload"),
          borderRadius: "0 !important",
          pb: 1,
        }}
        variant="text"
        onClick={() => setActiveTab("upload")}
      >
        Final Upload
      </Button>
      <Button
        sx={{
          fontWeight: "bold",
          borderBottom: isTabButtonActive("delivery"),
          borderRadius: "0 !important",
          pb: 1,
        }}
        variant="text"
        onClick={() => setActiveTab("delivery")}
      >
        Delivery
      </Button>
    </Stack>
  );
};

TabButtons.propTypes = {
  activeTab: PropTypes.string.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  commentsWaitingApproval: PropTypes.number.isRequired,
};

export default TabButtons;
